import { isEmail } from 'shared/lib'
import { ContactsApi } from '../api/contacts'

export const isEmailMessage = async (email: string) => {
  if (!isEmail(email)) {
    return Promise.reject('Please enter a valid email')
  }
  return ContactsApi.createValidation({ email })
}
